export enum GTMEventType {
  PRODUCT_CONFIGURATOR = 'product_configurator',
  ERROR_EVENT = 'error_event',
}
